export default function getCurrentMonth() {
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ]
  const date = new Date()
  const monthNumber = date.getMonth().toString()
  const month = months[monthNumber]
  return month
}
